// extracted by mini-css-extract-plugin
export default {"root":"e_M6KD","text":"KezIZB","icon":"RudyHs"};